import { render } from "./examList.vue?vue&type=template&id=57b4c642&scoped=true"
import script from "./examList.vue?vue&type=script&lang=js"
export * from "./examList.vue?vue&type=script&lang=js"

import "./examList.vue?vue&type=style&index=0&id=57b4c642&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b4c642"]])

export default __exports__